import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay,Pagination  } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import './Style.css'
import { FaQuoteLeft } from "react-icons/fa";

const Testimonials = () => {
  return (   
   <Swiper
  modules={[Navigation, Autoplay, Pagination]}
  spaceBetween={30}
  slidesPerView={3}
  loop
  navigation
  pagination={{ clickable: true }}
  autoplay={{
    delay: 4000,
    disableOnInteraction: false,
  }}
  breakpoints={{
    0: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    992: { slidesPerView: 3 },
  }}
>
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="testimonialCard">
            <div className="iconWrapper">
              <FaQuoteLeft className="quoteIcon" />
            </div>
            <div className="quoteBox">
              <p>
                A wealth creator who truly understands a client needs, aspiration, and goals.
              </p>
              <hr />
              <div className="name">Gautam Ganglani</div>
              <div className="designation">CEO - Right Selection Global Thought</div>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <div className="testimonialCard">
            <div className="iconWrapper">
              <FaQuoteLeft className="quoteIcon" />
            </div>
            <div className="quoteBox">
              <p>
                My SIPs were all over the place. Plan2Prosper gave me structure
                and clarity.
              </p>
              <hr />
              <div className="name">Meera Sharma</div>
              <div className="designation">Marketing Manager · Pune</div>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 3 */}
        {/* <SwiperSlide>
          <div className="testimonialCard">
            <div className="iconWrapper">
              <FaQuoteLeft className="quoteIcon" />
            </div>
            <div className="quoteBox">
              <p>They don’t push products. They plan like professionals.</p>
              <hr />
              <div className="name">Karan Patel</div>
              <div className="designation">Entrepreneur · Bengaluru</div>
            </div>
          </div>
        </SwiperSlide> */}

        {/* Slide 4 */}
        <SwiperSlide>
          <div className="testimonialCard">
            <div className="iconWrapper">
              <FaQuoteLeft className="quoteIcon" />
            </div>
            <div className="quoteBox">
              <p>I am using Bhuvanaa's services and I would highly recommend her to one and all.I am satisfied with her guidance.</p>
              <hr />
              <div className="name">Sunil Motwani</div>
              <div className="designation">Partner, M.B Builders</div>
            </div>
          </div>
        </SwiperSlide>

          {/* Slide 5 */}
        <SwiperSlide>
          <div className="testimonialCard">
            <div className="iconWrapper">
              <FaQuoteLeft className="quoteIcon" />
            </div>
            <div className="quoteBox">
              <p>A right mix of Professional expertise & understanding of Psychology, defines Bhuvana as a perfect financial advisor.</p>
              <hr />
              <div className="name">Gopal VK</div>
              <div className="designation">Member @ DFW Angles</div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
  );
};

export default Testimonials;
